<template>
  <v-container fluid>
    <v-row>
      <div class="header">
        <h2>Контакты межкафедральной учебно-научной лаборатории «Гербарий-SV»</h2>
      </div>
      <div class="horizontal-rule"/>

      <v-card class="contacts__text" tile>
        <v-row v-for="(item, index) in contactsBlobArray" key="index" :class="{'mt-0': index !== 0}">
          <v-col sm="8">{{item}}</v-col>
        </v-row>

        <div class="contacts__map mt-2">
          <v-card height="100%" width="100%">
            <v-img height="100%" width="100%" class="grey lighten-2">
              <YandexMaps class="ma-0" v-if="!loading" :zoom="16" :coordinates="this.coordinatesHerb"/>
              <template v-slot:placeholder>
                <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                  <v-progress-circular
                      v-if="loading"
                      indeterminate
                      color="primary"
                      width="3"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </div>

      </v-card>

      <div class="header">
        <h2>Научный руководитель лаборатории</h2>
      </div>
      <div class="horizontal-rule"/>

      <v-card class="contacts__text contacts__text_bottom mt-3" tile>
        <div v-for="(item, index) in leadsBlobArray" key="index">{{item}}</div>
      </v-card>

      <div class="header mt-0">
        <h2>Кураторы гербария</h2>
      </div>
      <div class="horizontal-rule"/>

      <v-card class="contacts__text contacts__text_bottom mt-3" tile>
        <div v-for="(item, index) in curatorsBlobArray" key="index">{{item}}</div>
      </v-card>

      <div class="header mt-0">
        <h2>Авторы системы</h2>
      </div>
      <div class="horizontal-rule"/>

      <v-card class="contacts__text contacts__text_bottom mt-3" tile>
        <div v-for="(item, index) in authorsBlobArray" key="index">{{item}}</div>
      </v-card>

    </v-row>
  </v-container>
</template>

<script>
import YandexMaps from "@/components/YandexMaps";
export default {
  name: 'ContactsPage',

  components: {YandexMaps},

  data() {
    return {
      loading: true,
      contactsBlobArray: [
          'Адрес: 443011, г. Самара, ул. Академика Павлова, д. 1, Самарский национальный исследовательский университет имени академика С.П. Королева, к. 22, лаб. 607, 612',
          'Тел.: 8 (846) 334-54-43',
          'E-mail: herbarium-smr@yandex.ru'
      ],
      leadsBlobArray: [
          'Д.б.н. Н.В. Прохорова'
      ],
      curatorsBlobArray: [
        'Я.А. Богданова (мохообразные)',
        'Е.С. Корчиков (лишайники)',
        'Т.А. Корчикова, О.А. Кузовенко, Ю.В. Макарова, И.В. Шаронова (сосудистые растения)'
      ],
      authorsBlobArray: [
          'К.ф.-м.н. М.С. Русакова – руководитель группы',
          'А.И. Нуйкин, Д.С. Пастушенко, Н.С. Перевышин – разработчики системы',
          'И.В. Шаронова, А.С. Курочкин – авторы идеи'
      ],

      coordinates: [53.211967, 50.177502],
      coordinatesHerb: [53.222643, 50.173038]
    }
  },

  methods: {
  },

  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 750)
  }
}
</script>

<style scoped>

</style>